import { takeEvery } from 'redux-saga/effects';

import * as homeActions from 'store/modules/home';
import { loadBlogPosts } from './utils';

export default function* listenLoadBlogPosts() {
  yield takeEvery(homeActions.loadBlogPosts.toString(), loadBlogPosts);
}
